<div class="flex bg-surface-switch-0">
  <div
    class="w-full md:w-6/12 px-12 py-20 md:px-20 flex flex-col gap-8 min-h-160 justify-center"
  >
    @if (!loading()) {
      <div>
        <p-tag severity="danger" value="Access denied"></p-tag>
      </div>
      <div class="flex flex-col gap-4">
        <h1 class="text-5xl font-bold text-surface-switch-900 leading-tight">
          You don't have access to this workspace
        </h1>
        <p class="text-lg text-surface-switch-500 leading-normal">
          This account isn't a member of this workspace. If you think this is a
          mistake, ask a team admin to invite you.
        </p>
        @if (email(); as signedInEmail) {
          <p class="text-base text-surface-switch-500">
            Signed in as
            <span class="font-semibold text-surface-switch-900">{{
              signedInEmail
            }}</span>
          </p>
        }
      </div>
      <div class="flex items-center gap-6">
        <button
          pButton
          [text]="true"
          class="text-base! leading-normal!"
          (click)="signInWithDifferentAccount()"
        >
          <i pButtonIcon class="pi pi-sign-out"></i>
          <span pButtonLabel>Sign in with a different account</span>
        </button>
      </div>
    }
  </div>
  <div
    class="w-full md:w-6/12 hidden md:block"
    style="
      background:
        linear-gradient(
          0deg,
          var(--p-primary-500) 0%,
          var(--p-primary-500) 100%
        ),
        url(&quot;https://fqjltiegiezfetthbags.supabase.co/storage/v1/object/public/block.images/blocks/pagenotfound/pagenotfound-split.jpg&quot;)
          lightgray 50% / cover no-repeat;
      background-blend-mode: overlay, normal;
    "
  ></div>
</div>
